export default __webpack_public_path__ + "static/media/top-first-view-arrow.428c8caa.svg";